/* unplugin-vue-components disabled */import { render } from "./career.vue?vue&type=template&id=2909f72c&scoped=true"
import script from "./career.vue?vue&type=script&lang=js"
export * from "./career.vue?vue&type=script&lang=js"

import "./career.vue?vue&type=style&index=0&id=2909f72c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2909f72c"],['__file',"src/components/cards-v2/persona/career.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2909f72c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2909f72c', __exports__)) {
    api.reload('2909f72c', __exports__)
  }
  
  module.hot.accept("./career.vue?vue&type=template&id=2909f72c&scoped=true", () => {
    api.rerender('2909f72c', render)
  })

}


export default __exports__